/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Save_FailedInputs */



/**
* | output |
* | --- |
* | "We could not save your template." |
*
* @param {Settings_Template_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_save_failed = /** @type {((inputs?: Settings_Template_Save_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Save_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je template niet opslaan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu enregistrer votre modèle.")
	return /** @type {LocalizedString} */ ("We could not save your template.")
});